import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-application-fab-content',
    imports: [
        MatButtonModule,
        MatIconModule
    ],
    templateUrl: './application-fab-content.component.html',
    styleUrl: './application-fab-content.component.scss'
})
export class ApplicationFabContentComponent {

  public scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

}
